const pollForDefinition = (scope, varname, callback, conditionCheck = null) => {
  const checkAndExecute = () => {
    if (typeof scope[varname] !== 'undefined') {
      if (conditionCheck) {
        if (conditionCheck()) {
          callback();
          return true;
        }
      } else {
        callback();
        return true;
      }
    }
    return false;
  };

  if (checkAndExecute()) {
    return;
  }

  const interval = setInterval(() => {
    if (checkAndExecute()) {
      clearInterval(interval);
    }
  }, 250);
};

export default pollForDefinition;
